import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DivisionView, SearchDivisionsParameters } from '@api-proxies';
import { DepartmentService } from '@http/clients/department.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-department-editor',
    templateUrl: './department-editor.component.html',
    styleUrls: ['./department-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent, ValidationErrorMessageComponent]
})
export class DepartmentEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    departments?: DivisionView[];
    selectedDepartment?: DivisionView;

    constructor(private readonly departmentService: DepartmentService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.departments = await this.departmentService.search({
            isActive: this.additionalInfo?.isActive
        } as SearchDivisionsParameters);

        if (this.bindingProperty) {
            this.selectedDepartment = this.departments?.find((x) => x.id === this.bindingProperty);
            if (!this.selectedDepartment) {
                this.selectedDepartment = await this.departmentService.getById(this.bindingProperty);
            }
        }
    }

    onDepartmentChange() {
        if (this.selectedDepartment?.id) {
            this.bindingProperty = this.selectedDepartment.id;
            this.validate();
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }
}
